import React from 'react'
import T from 'prop-types'
import IT from 'react-immutable-proptypes'
import cx from 'classnames'
import {
  DropdownMenu,
  MenuItem
} from 'react-base'
import Schema from '../Schema'
import MapperFieldToken, {
TOKEN_DND_ITEM_TYPE
} from './MapperFieldToken'
import {
  SCHEMA_ITEM_SHAPE,
  COLUMN_SHAPE,
  SCHEMA_SHAPE
} from '../shapes'
// Single sortable item

export default class MapperRowHeading extends React.PureComponent {
  static displayName = 'MapperRowHeading'

  static propTypes = {
    rowIndex: T.number.isRequired,
    row: IT.map,
    schema: SCHEMA_SHAPE,

    onRowChange: T.func.isRequired
  }

  render() {
    const {
      rowIndex
    } = this.props

    return (
      <div
        className={cx(
          `mapper_row_heading`
        )}
      >
        <div className="column_number">
          RO here
        </div>
      </div>
    )
  }
}
